/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { COLOR } from 'assets/styles/colors';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';
import { useHistory } from 'react-router-dom';

import PATH from 'routes/path';

import TrackingBing from 'components/TrackingBing';
import { StyledDialog, Content, BoxButtons } from './styles';

const PaymentModal = ({
  idCase, isPagSeguro,
  onClose, open, alreadyPaid, price,
}) => {
  const history = useHistory();

  const destiny = isPagSeguro ? 'Atermação' : 'Documentos';

  useEffect(() => {
    if (open && alreadyPaid) {
      TrackingBing.initialize(process.env.REACT_APP_BT_ID);
      TrackingBing.trackEvent('purchase', price, 'BRL');
    }
  }, [open, alreadyPaid]);

  return (
    <StyledDialog
      open={open}
      onClose={() => !alreadyPaid && onClose(false)}
    >
      <Content alreadyPaid={alreadyPaid}>
        {!alreadyPaid && (
          <IconButton
            style={{ color: alreadyPaid ? COLOR.GREEN_1 : COLOR.RED_1 }}
            onClick={() => onClose(false)}
          >
            <CloseIcon onClick={() => onClose(false)} />
          </IconButton>
        )}
        <Title>{alreadyPaid ? 'Pagamento já realizado!' : 'Erro ao concluir compra!'}</Title>
        <Title secondary>
          {alreadyPaid
            ? `O seu pagamento já foi aprovado, agora você pode continuar para a página de ${destiny} ou voltar para a tela inicial através dos botões abaixo.`
            : 'Por algum motivo o seu cartão não foi aceito para o pagamento'}

        </Title>
        {!alreadyPaid && (
          <Text>
            Indicamos realizar a compra novamente utilizando outro cartão ou verificar junto ao seu banco as condições do cartão utilizado antes de tentar novamente
          </Text>
        )}
        <BoxButtons>
          <Button
            onClick={() => history.push(PATH.HOME)}
            variant="outlined"
            className="unset"
            style={{ display: alreadyPaid && 'none' }}
          >
            Cancelar
          </Button>
          {
            alreadyPaid && (
              <Button onClick={() => history.push({
                pathname: isPagSeguro ? PATH.ATERMACAO : PATH.DOCUMENTS,
                state: { idCase },
              })}
              >
                Continuar para
                {' '}
                {destiny}
              </Button>
            )
          }
          <Button
            variant={alreadyPaid ? 'outlined' : 'contained'}
            onClick={alreadyPaid ? () => history.push({ pathname: '/home', state: { idCase } }) : () => onClose(false)}
          >
            {alreadyPaid ? 'Voltar para a tela inicial' : 'Tentar novamente'}
          </Button>
        </BoxButtons>
      </Content>
    </StyledDialog>
  );
};

PaymentModal.propTypes = {
  idCase: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  alreadyPaid: PropTypes.bool.isRequired,
  isPagSeguro: PropTypes.bool.isRequired,
  price: PropTypes.string.isRequired,
};

export default PaymentModal;
